{
  "conflict": {
    "title": "Conflicto de programación detectado",
    "defaultMessage": "Otro usuario ha modificado la posición de esta aeronave. Tus cambios podrían sobrescribir los suyos.",
    "attemptProgress": "Intento {{current}} de {{max}}",
    "retryExplanation": "• Reintentar intentará guardar tus cambios nuevamente, lo que podría sobrescribir los cambios del otro usuario.",
    "cancelExplanation": "• Cancelar descartará los cambios y recargará el estado actual.",
    "cancelButton": "Cancelar cambios",
    "retryButton": "Reintentar"
  },
  "confirmation": {
    "defaultCancel": "Cancelar",
    "defaultOk": "OK",
    "typeToConfirm": "Escribe 'eliminar' para confirmar la eliminación.",
    "deletePlaceholder": "eliminar"
  },
  "progress": {
    "defaultItemName": "ítem",
    "processing": "Procesando {{current}} de {{total}} {{itemName}}",
    "processingPlural": "Procesando {{current}} de {{total}} {{itemName}}",
    "currentLabel": "Actual: {{currentItem}}"
  },
  "error": {
    "defaultTitle": "Ups, algo salió mal",
    "defaultDescription": "Ocurrió un error inesperado.",
    "teamNotified": "El equipo de AirPlx ha sido notificado y está investigando el problema.",
    "errorDetailsLabel": "Detalles del error (solo dev):",
    "componentStackLabel": "Pila de componentes",
    "refreshButton": "Actualizar página",
    "returnHome": "Volver al inicio"
  },
  "notes": {
    "title": "Notas de aeronave",
    "label": "Notas",
    "placeholder": "Hora de salida: 24/05/2025 12:00",
    "lastUpdate": "Última actualización: {{time}} ({{date}}) por {{user}}",
    "cancelButton": "Cancelar",
    "saveButton": "Guardar"
  }
}
